// extracted by mini-css-extract-plugin
export default {"priceDrop":"pricedrop-tag_priceDrop__rhaxm"};